import { render, staticRenderFns } from "./CreateMemo.vue?vue&type=template&id=295220ff&scoped=true&"
import script from "./CreateMemo.vue?vue&type=script&lang=js&"
export * from "./CreateMemo.vue?vue&type=script&lang=js&"
import style0 from "./CreateMemo.vue?vue&type=style&index=0&id=295220ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.9.5_@vue+compiler-sfc@3.5.44_babel-core@7.0.0-bridge.0_@babel+core@7.12.8_bab05b83ea19148beb1746204d3ff44c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295220ff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('295220ff')) {
      api.createRecord('295220ff', component.options)
    } else {
      api.reload('295220ff', component.options)
    }
    module.hot.accept("./CreateMemo.vue?vue&type=template&id=295220ff&scoped=true&", function () {
      api.rerender('295220ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/patient/components/Memo/components/CreateMemo.vue"
export default component.exports